import campaignActionSharedState  from '@/campaign-action-shared/store/state'

export default {
  ...campaignActionSharedState,

  petition: {
    slug: null,
    successful: false,
    progressBarHidden: false,
    sharingAllowed: true,
    signatureFormHidden: false,
    signersWriteToTarget: false,
    hasImage: false,
    categoryIds: []
  },

  alreadySignedOnPageLoad: false,
  shareButtonClicked: false,

  progress: {
    progressPercentage: 0,
    currentSignaturesCount: 0,
    currentSignaturesGoal: 0
  },

  showUnconfirmedSignaturesDisclaimer: false,

  signed: false,
  signTitle: null,

  recentActions: [],

  createPetitionCommentPath: null,

  categoriesModalOpen: false,
  imageUploadModalOpen: false,
  showingShareBanner: false
}
